// Centralized French content for Pronospot.com
// Mirrors the backend dataset to allow fast static rendering with optional API hydration.

export const BOOKMAKERS = [
    {
        slug: "unibet",
        name: "Unibet",
        shortName: "UNB",
        bonus: "110 € de Freebet sur le 1er pari perdant",
        bonusShort: "110 €",
        score: 9.2,
        stars: 5,
        badge: "#1 France",
        color: "#147B45",
        tags: ["Fusion FDJ 2026", "Triple offre sport/turf/poker", "App mobile 4.6/5", "Virement instantané"],
        pros: [
            "Classé #1 en France mai 2026",
            "Plus grand nombre de marchés (200+)",
            "Triple offre sport, turf, poker",
            "Bet Builder très complet",
            "Excellente app mobile",
            "Livestreaming inclus",
        ],
        cons: [
            "Frais virement instantané possibles selon banque",
            "Cotes légèrement inférieures à Winamax",
            "Interface parfois chargée",
            "Bonus en freebets (pas en cash)",
        ],
        description:
            "Unibet est le N°1 français en mai 2026 depuis sa fusion avec Parions Sport. Il propose une offre triple complète (sport, turf, poker), une application mobile de référence notée 4.6/5 et le plus grand catalogue de marchés en France.",
        affiliateUrl: "https://www.unibet.fr",
        oddsAvg: "Très élevé",
        markets: 200,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Skrill", "Virement"],
        support: "Chat & Email 24/7",
        license: "✓ ANJ - Fusion FDJ 2026",
        verdict:
            "Verdict : Unibet est le choix naturel pour la Coupe du Monde 2026. Sa fusion avec Parions Sport lui confère la plus grande offre de marchés en France (200+ par match), une triple licence ANJ et une application mobile de référence. Le Bet Builder et le livestreaming vidéo en font la plateforme la plus complète du marché français.",
        bonusSteps: [
            "Inscrivez-vous via le bouton 'Accéder au site'",
            "Validez votre compte avec une pièce d'identité",
            "Effectuez un premier dépôt (10 € minimum)",
            "Placez un premier pari simple sur n'importe quel sport",
            "Recevez 110 € en freebets si votre 1er pari est perdant",
        ],
    },
    {
        slug: "betclic",
        name: "Betclic",
        shortName: "BTC",
        bonus: "100 € de bonus en Cash Retirable",
        bonusShort: "100 €",
        score: 8.9,
        stars: 5,
        badge: "App 4.7/5",
        color: "#E60028",
        tags: ["Bonus cash retirable", "Meilleure application mobile", "Idéal débutants", "Livestreaming inclus"],
        pros: [
            "App la mieux notée du marché (4.7/5)",
            "Bonus cash retirable directement",
            "Expérience utilisateur soignée",
            "Triple licence ANJ complète",
            "Idéal pour les débutants",
        ],
        cons: [
            "Cotes légèrement sous Winamax",
            "Moins de marchés qu'Unibet",
            "Bet Builder moins développé",
        ],
        description:
            "Betclic est le leader de l'expérience mobile avec l'application la mieux notée du marché ANJ (4.7/5). Il offre un bonus unique de 100 € remboursé en cash réel directement retirable si le 1er pari est perdant.",
        affiliateUrl: "https://www.betclic.fr",
        oddsAvg: "Élevé",
        markets: 200,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Apple Pay"],
        support: "Chat & Email - Réponse rapide",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Betclic est le choix idéal pour les parieurs mobiles et les débutants. Son application, la mieux notée du marché ANJ (4.7/5), combinée à un bonus en cash retirable sans condition de mise, en fait une valeur sûre. Betclic et Unibet se complètent parfaitement comme duo de comptes principaux.",
        bonusSteps: [
            "Ouvrez un compte sur Betclic via notre lien",
            "Envoyez vos documents justificatifs pour valider le compte",
            "Faites un premier dépôt de 10 € minimum",
            "Placez un premier pari jusqu'à 100 €",
            "Si le pari est perdant, Betclic vous rembourse 100 € en cash directement retirable",
        ],
    },
    {
        slug: "winamax",
        name: "Winamax",
        shortName: "WMX",
        bonus: "100 € Cash retirable + 250 € Poker",
        bonusShort: "100 €",
        score: 8.8,
        stars: 5,
        badge: "Meilleures cotes",
        color: "#FFCC00",
        tags: ["N°1 cotes Odoxa", "Bonus cash retirable", "Retrait instantané des gains", "Top site Poker"],
        pros: [
            "Meilleures cotes ANJ (Odoxa)",
            "Bonus en cash retirable immédiatement",
            "Retrait instantané des gains",
            "Meilleur site poker de France",
            "Choix naturel des parieurs pro",
        ],
        cons: [
            "Pas de chat client en direct",
            "Aucune offre turf",
            "App mobile perfectible",
            "Fin du Jeu de l'Entraîneur (2025)",
        ],
        description:
            "Winamax est réputé pour offrir les meilleures cotes de France selon les études Odoxa. Son bonus de bienvenue de 100 € est remboursé en cash sans condition de mise, cumulable avec 250 € de bonus de poker.",
        affiliateUrl: "https://www.winamax.fr",
        oddsAvg: "N°1 Odoxa",
        markets: 200,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Email 24/7 (Pas de chat en direct)",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Winamax est le bookmaker des parieurs qui cherchent à optimiser leurs gains. Les meilleures cotes du marché (n°1 Odoxa sur 4 803 matchs analysés), un bonus 100 % cash retirable et un retrait instantané en font la référence pour les parieurs expérimentés. Seule ombre : l'absence de turf et de chat en direct.",
        bonusSteps: [
            "Créez votre compte Winamax",
            "Effectuez un premier dépôt (jusqu'à 100 €)",
            "Validez définitivement votre compte avec vos justificatifs",
            "Placez votre premier pari sportif",
            "Si le pari est perdant, recevez 100% de remboursement en cash réel retirable",
        ],
    },
    {
        slug: "bet365",
        name: "Bet365",
        shortName: "B365",
        bonus: "100 € de Freebets à l'inscription",
        bonusShort: "100 €",
        score: 8.6,
        stars: 4,
        badge: "Leader mondial",
        color: "#042C53",
        tags: ["300+ marchés par match", "Bet Builder ultra complet", "Expected Goals (xG)", "Livestreaming massif"],
        pros: [
            "300+ marchés par match (record)",
            "Livestreaming massif inclus",
            "Bet Builder ultra complet",
            "Stats avancées (xG, heatmaps)",
            "Notoriété mondiale rassurante",
        ],
        cons: [
            "Encore récent sur le marché ANJ",
            "Bonus sans particularité",
            "Pas encore d'offre poker ANJ",
            "Promotions en construction",
        ],
        description:
            "Géant mondial du pari sportif entré sur le marché ANJ. Bet365 apporte un livestreaming exceptionnel, des statistiques analytiques poussées et le Bet Builder le plus avancé du monde.",
        affiliateUrl: "https://www.bet365.fr",
        oddsAvg: "Élevé",
        markets: 300,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Skrill"],
        support: "Chat 24/7 & Téléphone",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Bet365 est une référence mondiale qui s'installe solidement sur le marché français. Son Bet Builder, son livestreaming massif et ses statistiques avancées (expected goals, heat maps) en font le meilleur outil pour le parieur analytique. À terme, il pourrait rivaliser avec Unibet pour la première place.",
        bonusSteps: [
            "Inscrivez-vous sur le site de Bet365 France",
            "Validez vos pièces d'identité",
            "Déposez minimum 10 €",
            "Placez vos paris qualificatifs",
            "Recevez jusqu'à 100 € en freebets d'inscription",
        ],
    },
    {
        slug: "olybet",
        name: "OlyBet",
        shortName: "OLY",
        bonus: "100 € de Freebets par paliers",
        bonusShort: "100 €",
        score: 7.4,
        stars: 4,
        badge: "Fidélité & VIP",
        color: "#3B6D11",
        tags: ["Cotes basket NBA compétitives", "Programme de fidélité VIP", "OlyBoost cotes hebdomadaires", "Places matchs offertes"],
        pros: [
            "Meilleur programme fidélité ANJ",
            "Offres exclusives places de match",
            "Cotes basket très compétitives",
            "OlyBoost : cotes boostées uniques",
            "Livestreaming disponible",
        ],
        cons: [
            "Bonus difficile à débloquer",
            "Offre encore en développement",
            "Moins de marchés que les #1-4",
            "Notoriété limitée en France",
        ],
        description:
            "OlyBet se distingue par son programme de fidélité exceptionnel et ses partenariats exclusifs avec des clubs sportifs français, permettant aux parieurs d'obtenir des places de match VIP.",
        affiliateUrl: "https://www.olybet.fr",
        oddsAvg: "Moyen",
        markets: 140,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Formulaire de contact & Email",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : OlyBet est le bookmaker de la fidélité et des amateurs de basket. Son programme OlyBoost avec des cotes surcotées exclusives et ses partenariats avec des clubs sportifs (places de match offertes) constituent une vraie différenciation. À recommander en compte secondaire pour les fans de basket et rugby.",
        bonusSteps: [
            "Créez votre compte sur OlyBet",
            "Validez vos justificatifs d'identité",
            "Déposez et commencez à parier",
            "Misez un volume cumulé de 550 € pour débloquer la totalité du bonus",
            "Recevez progressivement vos 100 € en freebets",
        ],
    },
    {
        slug: "betsson",
        name: "Betsson",
        shortName: "BTS",
        bonus: "10 € sans dépôt + 100 € remboursés",
        bonusShort: "110 €",
        score: 7.2,
        stars: 4,
        badge: "Sans Dépôt",
        color: "#27500A",
        tags: ["Unique bonus sans dépôt 10 €", "Meilleures cotes football", "Gains max 1 000 000 €", "BetSwipe rapide"],
        pros: [
            "Unique bonus sans dépôt ANJ",
            "Cotes football excellentes",
            "BetSwipe — fonctionnalité innovante",
            "Gains potentiels jusqu'à 1 M€",
            "Idéal comme compte test",
        ],
        cons: [
            "Second plan face aux leaders",
            "Conditions bonus complexes",
            "Moins de marchés globalement",
            "Notoriété faible en France",
        ],
        description:
            "Betsson est le seul bookmaker en France à offrir un vrai bonus sans dépôt de 10 € dès la validation du compte, idéal pour tester la plateforme, en plus d'un remboursement jusqu'à 100 €.",
        affiliateUrl: "https://www.betsson.fr",
        oddsAvg: "Excellent",
        markets: 150,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "PayPal", "Skrill", "Virement"],
        support: "Formulaire & Chat en direct",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Betsson est une porte d'entrée idéale grâce à son bonus sans dépôt unique en France. Son BetSwipe innove dans l'expérience de jeu et ses cotes football dominent le marché ANJ selon plusieurs études. À tester absolument — pas forcément comme compte principal, mais comme compte secondaire pour les amateurs de foot.",
        bonusSteps: [
            "Inscrivez-vous sur Betsson",
            "Validez votre compte pour recevoir immédiatement 10 € sans dépôt",
            "Effectuez un premier dépôt pour activer l'offre principale",
            "Placez votre premier pari sportif",
            "Si votre pari est perdant, obtenez un remboursement jusqu'à 100 € sous forme de BetBoosts (freebets)",
        ],
    },
    {
        slug: "bwin",
        name: "bwin",
        shortName: "BWN",
        bonus: "100 € de Freebets à l'inscription",
        bonusShort: "100 €",
        score: 6.9,
        stars: 3,
        badge: "Historique",
        color: "#712B13",
        tags: ["Pionnier historique", "Livestreaming de qualité", "Invitations évènements sportifs", "Bonus rénové 2025"],
        pros: [
            "Marque historique de confiance",
            "Livestreaming de qualité",
            "Invitations events sportifs",
            "Bonus rénové plus attractif",
            "Service client fiable",
        ],
        cons: [
            "Cotes dans la moyenne basse",
            "Bonus sport/poker non cumulables",
            "Offre en perte de vitesse",
            "Moins innovant que les concurrents",
        ],
        description:
            "Pionnier historique du pari en ligne, bwin a modernisé son offre de bienvenue en 2025. Il dispose d'une solide plateforme de livestreaming et offre des places exclusives pour des événements sportifs.",
        affiliateUrl: "https://www.bwin.fr",
        oddsAvg: "Moyen",
        markets: 160,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Skrill", "Virement"],
        support: "Chat en direct & Email",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : bwin est un bookmaker historique qui cherche un second souffle. Son livestreaming reste un vrai point fort, tout comme ses invitations à des événements sportifs. Pour les parieurs qui valorisent la confiance d'une marque établie et un bon suivi vidéo des matchs, bwin reste une option solide en compte secondaire.",
        bonusSteps: [
            "Créez un compte bwin",
            "Faites un premier dépôt de 10 € minimum",
            "Placez votre 1er pari sportif",
            "Si le pari est perdant, recevez votre remboursement en freebets jusqu'à 100 €",
            "Note : Le bonus de poker de 100 € n'est pas cumulable avec l'offre sportive",
        ],
    },
    {
        slug: "pmu-sport",
        name: "PMU Sport",
        shortName: "PMU",
        bonus: "100 € Cash retirable + 200 € Turf & Poker",
        bonusShort: "100 €",
        score: 7.6,
        stars: 4,
        badge: "Référence Turf",
        color: "#633806",
        tags: ["Bonus sport 100 € en cash", "Référence hippique nationale", "Cotes élevées Odoxa", "Combinés mutualisés"],
        pros: [
            "Institution de confiance depuis 1930",
            "Bonus cash retirable",
            "Meilleure offre turf du marché",
            "Cotes excellentes (Odoxa)",
            "Combinés mutualisés innovants",
        ],
        cons: [
            "Délai de versement bonus parfois long",
            "App mobile perfectible",
            "Image vieillissante hors turf",
            "Moins d'innovations digitales",
        ],
        description:
            "Institution française historique, PMU Sport propose un bonus de bienvenue unique en cash retirable sans conditions de mise, en plus d'être l'incontestable référence nationale du Turf.",
        affiliateUrl: "https://www.pmu.fr",
        oddsAvg: "Élevé",
        markets: 150,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Téléphone & Formulaire",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : PMU Sport est une institution incontournable pour les turfistes et une alternative sérieuse pour les parieurs sportifs. Son bonus en cash directement retirable et ses cotes classées parmi les meilleures d'ANJ (étude Odoxa) en font un compte principal crédible. Incontournable si vous pariez aussi sur les courses hippiques.",
        bonusSteps: [
            "Inscrivez-vous sur PMU Sport",
            "Déposez minimum 10 €",
            "Placez un premier pari sportif jusqu'à 100 €",
            "Validez votre compte avec vos justificatifs",
            "Si votre pari est perdant, vous recevrez 100 € remboursés en argent réel (cash) directement retirable",
        ],
    },
    {
        slug: "genybet",
        name: "Genybet",
        shortName: "GNY",
        bonus: "50 € Sport + 250 € Turf cumulables",
        bonusShort: "250 €",
        score: 6.2,
        stars: 3,
        badge: "Turf & Hippique",
        color: "#3B6D11",
        tags: ["Spécialiste Turf complet", "Bonus cumulable 300 €", "1er pari live remboursé", "Plateforme simple"],
        pros: [
            "Offre turf très complète",
            "Bonus cumulable jusqu'à 300 €",
            "Pari live remboursé (20 €)",
            "Plateforme stable et simple",
        ],
        cons: [
            "Bonus sport limité (50 €)",
            "Offre sport moins complète",
            "Peu connu du grand public",
            "Peu de fonctionnalités avancées",
        ],
        description:
            "Genybet est un spécialiste des courses hippiques qui propose une section sport simple d'utilisation, avec un premier pari live remboursé en freebet jusqu'à 20 €.",
        affiliateUrl: "https://www.genybet.fr",
        oddsAvg: "Moyen",
        markets: 100,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Formulaire de contact",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Genybet est avant tout un spécialiste du turf avec une offre hippisme solide et un bonus cumulable atteignant 300 €. Pour les parieurs sportifs purs, l'offre reste limitée. À considérer uniquement si vous pariez à la fois sur les courses et le sport, pour maximiser les avantages combinés.",
        bonusSteps: [
            "Créez un compte Genybet",
            "Validez vos pièces justificatives",
            "Effectuez votre premier dépôt",
            "Placez votre 1er pari sport de 50 € maximum, et un pari live remboursé de 20 €",
            "Profitez également de l'offre Turf cumulable allant jusqu'à 250 €",
        ],
    },
    {
        slug: "netbet",
        name: "NetBet",
        shortName: "NET",
        bonus: "Offre de bienvenue suspendue",
        bonusShort: "Suspendu",
        score: 5.8,
        stars: 3,
        badge: "Pas de bonus",
        color: "#501313",
        tags: ["Plateforme fiable et stable", "Interface simple d'accès", "Cotes correctes football", "Cash-out disponible"],
        pros: [
            "Plateforme fiable et stable",
            "Simple à utiliser",
            "Cotes honnêtes sur le foot",
            "Service client disponible",
        ],
        cons: [
            "Aucun bonus de bienvenue (suspendu depuis juillet 2025)",
            "Peu de promotions régulières",
            "Pas d'innovations notables",
            "Faible notoriété",
            "Peu de marchés avancés",
        ],
        description:
            "NetBet a fait le choix de suspendre son bonus de bienvenue en juillet 2025. La plateforme se concentre sur sa stabilité technique et la simplicité de son interface pour fidéliser ses joueurs.",
        affiliateUrl: "https://www.netbet.fr",
        oddsAvg: "Correct",
        markets: 110,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Chat en direct & Formulaire",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : NetBet joue la carte de la discrétion et de la stabilité. Sans bonus de bienvenue depuis juillet 2025, il est difficile de le recommander à un nouveau parieur face à une concurrence bien plus généreuse. Reste une option pour les parieurs déjà inscrits qui apprécient sa simplicité, en attendant le retour d'une offre promotionnelle.",
        bonusSteps: [
            "Créez votre compte NetBet",
            "Validez votre identité",
            "Notez qu'aucun bonus de bienvenue n'est accordé actuellement",
            "Déposez minimum 10 € pour commencer à parier",
        ],
    },
    {
        slug: "pokerstars-sports",
        name: "PokerStars Sports",
        shortName: "PKS",
        bonus: "100 € de Freebets Sport",
        bonusShort: "100 €",
        score: 7.8,
        stars: 4,
        badge: "Sport & Poker",
        color: "#04342C",
        tags: ["Synergies sport / poker", "Livestreaming vidéo inclus", "Gains max illimités 1M€", "Marque mondiale reconnue"],
        pros: [
            "Marque poker mondialement connue",
            "Gains illimités possibles",
            "Livestreaming désormais inclus",
            "Promos croisées sport/poker",
            "Idéal pour joueurs polyvalents",
        ],
        cons: [
            "Offre sport moins mature",
            "Cotes dans la moyenne",
            "Moins de marchés que les leaders",
            "Interface moins intuitive",
        ],
        description:
            "PokerStars Sports offre une intégration parfaite pour les amateurs de poker et de paris sportifs, agrémentée depuis mai 2025 d'un service de livestreaming vidéo complet.",
        affiliateUrl: "https://www.pokerstarssports.fr",
        oddsAvg: "Moyen",
        markets: 170,
        liveStreaming: true,
        mobileApp: true,
        payments: ["CB", "PayPal", "Skrill", "Virement"],
        support: "Chat en direct & Formulaire",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : PokerStars Sports est le choix idéal pour les joueurs qui veulent combiner paris sportifs et poker sur une seule plateforme. L'intégration du livestreaming vidéo en 2025 et les gains potentiellement illimités sont de vrais arguments. À recommander en priorité aux fans de poker qui veulent aussi parier sur le sport.",
        bonusSteps: [
            "Inscrivez-vous sur PokerStars",
            "Validez votre compte avec vos justificatifs d'identité",
            "Faites un dépôt de 10 € minimum",
            "Misez sur votre 1er pari sportif",
            "Bénéficiez de 100 € en freebets et d'offres croisées pour le poker",
        ],
    },
    {
        slug: "feelingbet",
        name: "FeelingBet",
        shortName: "FLB",
        bonus: "300 € de bonus (50 € + 250 € Cashback)",
        bonusShort: "300 €",
        score: 6.4,
        stars: 3,
        badge: "Cashback 5 mois",
        color: "#72243E",
        tags: ["Cashback fidélité unique", "Bonus total élevé 300 €", "Idéal pour combinés", "Plateforme stable"],
        pros: [
            "Cashback fidélité unique ANJ",
            "Bonus total 300 € attractif",
            "Récompense les parieurs actifs",
            "Plateforme stable",
        ],
        cons: [
            "Volume de mises important requis",
            "Peu adapté aux débutants",
            "Faible notoriété",
            "Peu de marchés avancés",
            "Interface basique",
        ],
        description:
            "FeelingBet se démarque par son programme de fidélité original offrant jusqu'à 50 € de cashback par mois pendant 5 mois, conçu pour les parieurs réguliers adeptes de combinés.",
        affiliateUrl: "https://feelingbet.fr",
        oddsAvg: "Moyen",
        markets: 120,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Formulaire de contact",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : FeelingBet se distingue par son programme de fidélité cashback, unique sur le marché ANJ. Sa promesse : récompenser les parieurs réguliers sur combinés avec jusqu'à 50 € de cashback par mois pendant 5 mois. Intéressant comme compte secondaire pour les parieurs actifs, mais peu adapté aux débutants ou parieurs occasionnels.",
        bonusSteps: [
            "Créez votre compte sur FeelingBet",
            "Déposez et placez votre premier pari de 50 € (10 € remboursés immédiatement, 40 € à l'activation du compte)",
            "Chaque mois pendant 5 mois, pariez activement (notamment sur des combinés)",
            "Bénéficiez de jusqu'à 50 € de cashback mensuel selon votre volume de mises, pour un total de 300 €",
        ],
    },
    {
        slug: "circusbet",
        name: "CircusBet",
        shortName: "CRB",
        bonus: "100 € de Freebets à l'inscription",
        bonusShort: "100 €",
        score: 7.2,
        stars: 3,
        badge: "Opérateur ANJ",
        color: "#1A1A1A",
        tags: ["Nouveau bookmaker", "Cotes intéressantes", "Interface simplifiée", "100% sécurisé ANJ"],
        pros: [
            "Cotes très correctes sur le foot",
            "Interface claire et lisible",
            "Bonus simple d'utilisation",
            "Agréé ANJ",
        ],
        cons: [
            "Pas d'application mobile dédiée",
            "Moins de sports mineurs",
            "Support client restreint",
        ],
        description:
            "CircusBet est un opérateur agréé par l'ANJ en France, proposant une offre de paris sportifs classique avec un bonus de bienvenue de 100 €.",
        affiliateUrl: "https://www.circusbet.fr",
        oddsAvg: "Moyen",
        markets: 130,
        liveStreaming: false,
        mobileApp: false,
        payments: ["CB", "Virement"],
        support: "Email",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : CircusBet est un bookmaker simple et efficace. Idéal pour diversifier vos comptes et profiter d'un bonus supplémentaire de 100 € de freebets.",
        bonusSteps: [
            "Inscrivez-vous sur CircusBet",
            "Validez vos pièces d'identité",
            "Déposez minimum 10 €",
            "Placez votre 1er pari",
            "Recevez votre bonus de freebets",
        ],
    },
    {
        slug: "daznbet",
        name: "DAZN Bet",
        shortName: "DAZN",
        bonus: "100 € de bonus de bienvenue",
        bonusShort: "100 €",
        score: 7.3,
        stars: 3,
        badge: "Intégration DAZN",
        color: "#F5C200",
        tags: ["Nouveau bookmaker 2026", "Lien direct streaming DAZN", "Offre football variée", "Stats intégrées"],
        pros: [
            "Offre couplée avec l'abonnement DAZN",
            "Bonnes cotes sur le football européen",
            "Interface moderne et interactive",
            "Retraits rapides",
        ],
        cons: [
            "Pas de livestream vidéo direct sur le site",
            "Bonus soumis à conditions de mise",
            "Moins de marchés spéciaux",
        ],
        description:
            "DAZN Bet est la plateforme de paris sportifs officielle de la célèbre chaîne DAZN, proposant une intégration moderne avec les contenus sportifs.",
        affiliateUrl: "https://www.daznbet.fr",
        oddsAvg: "Moyen",
        markets: 140,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "Virement", "Skrill"],
        support: "Email & Chat",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : DAZN Bet est parfait si vous suivez la Ligue 1 et le football sur les chaînes DAZN. L'intégration de la plateforme de paris et du média sportif est prometteuse.",
        bonusSteps: [
            "Créez un compte sur DAZN Bet",
            "Validez votre profil d'utilisateur",
            "Faites un premier versement",
            "Pariez sur le football",
            "Recevez votre bonus de bienvenue",
        ],
    },
    {
        slug: "vbet",
        name: "Vbet",
        shortName: "VBT",
        bonus: "100 € remboursés en Freebets",
        bonusShort: "100 €",
        score: 7.5,
        stars: 4,
        badge: "Cotes combinés",
        color: "#FF006F",
        tags: ["Opérateur international", "Cotes combinés boostées", "Promotions récurrentes", "Interface moderne"],
        pros: [
            "Nombreux challenges et promotions",
            "Cotes boostées sur combinés",
            "Interface dynamique et personnalisable",
            "Support client disponible",
        ],
        cons: [
            "Conditions de validation rigides",
            "Cotes simples parfois moyennes",
            "Frais de virement selon banque",
        ],
        description:
            "Vbet est un bookmaker international agréé ANJ, reconnu pour son grand catalogue de promotions et ses excellentes fonctionnalités de paris combinés.",
        affiliateUrl: "https://www.vbet.fr",
        oddsAvg: "Moyen +",
        markets: 160,
        liveStreaming: false,
        mobileApp: true,
        payments: ["CB", "PayPal", "Virement"],
        support: "Chat en direct & Email",
        license: "✓ ANJ Licence validée",
        verdict:
            "Verdict : Vbet est un excellent choix secondaire pour les parieurs à la recherche de promotions quotidiennes et de cotes boostées sur les combinés.",
        bonusSteps: [
            "Inscrivez-vous sur le site de Vbet",
            "Validez vos pièces justificatives",
            "Faites un premier dépôt de 10 € ou plus",
            "Placez votre 1er pari de 100 € max",
            "Si perdant, obtenez 100 € de freebets remboursés",
        ],
    },
];

export const ARTICLES = [];

export const GUIDES = [
    {
        slug: "comment-parier-football",
        title: "Comment parier sur le foot : Guide débutant complet",
        excerpt: "Le guide ultime pour débuter dans les paris sportifs football : de l'inscription au premier pari gagnant.",
        category: "Débutant",
        readTime: "12 min",
        icon: "BookOpen",
        introduction: "Pour parier sur le football de manière intelligente, il faut d'abord choisir un bookmaker agréé par l'ANJ, bien comprendre le fonctionnement des cotes, et adopter une gestion rigoureuse de son budget de jeu (1% à 2% maximum par pari).",
        sections: [
            {
                id: "choisir-bookmaker",
                title: "Choisir un bookmaker fiable",
                content: "Le premier pas indispensable est d'ouvrir un compte chez un opérateur agréé par l'ANJ (Autorité Nationale des Jeux) comme Unibet, Winamax ou Betclic. Cela vous assure des retraits sécurisés, une équité des jeux, et des bonus de bienvenue légitimes."
            },
            {
                id: "comprendre-cotes",
                title: "Comprendre les cotes",
                content: "La cote décimale (ex: 2.15) représente le multiplicateur appliqué à votre mise en cas de pari gagnant. Par exemple, une mise de 10 € sur une cote de 2.15 vous rapporte 21,50 € au total, soit 11,50 € de profit net. Plus la cote est faible, plus le résultat est probable."
            },
            {
                id: "premier-pari",
                title: "Placer son premier pari",
                content: "Connectez-vous à votre compte, sélectionnez la compétition de votre choix, cliquez sur le résultat souhaité (1 pour l'équipe à domicile, N pour le nul, 2 pour l'équipe à l'extérieur), indiquez votre mise, puis valisez le ticket."
            },
            {
                id: "gestion-bankroll",
                title: "Gestion de bankroll",
                content: "Ne misez jamais la totalité de vos fonds sur un seul match. Définissez une bankroll (budget de jeu) et limitez chaque mise à 1% ou 2% maximum de cette somme. C'est l'unique secret pour durer et devenir bénéficiaire sur le long terme."
            },
            {
                id: "erreurs",
                title: "Erreurs à éviter",
                content: "Ne jouez jamais sous le coup de l'émotion pour vous refaire après une perte. Évitez les combinés géants de 10 matchs avec des cotes démesurées, car le risque de perdre est statistiquement trop élevé."
            }
        ],
        faqs: [
            {
                q: "Quel budget faut-il pour commencer à parier ?",
                a: "Vous pouvez débuter avec 10 € seulement. La plupart des sites de paris sportifs autorisent un dépôt minimum de 10 €."
            },
            {
                q: "Les gains de paris sportifs sont-ils imposables ?",
                a: "Non, en France, les gains issus des paris sportifs occasionnels ne sont pas soumis à l'impôt sur le revenu."
            },
            {
                q: "Puis-je parier sur mon téléphone portable ?",
                a: "Oui, tous les bookmakers agréés ANJ disposent d'applications mobiles performantes disponibles sur iOS et Android."
            }
        ]
    },
    {
        slug: "qu-est-ce-qu-un-freebet",
        title: "Qu'est-ce qu'un freebet ? Tout comprendre en 5 min",
        excerpt: "Définition, fonctionnement et stratégies pour optimiser vos paris gratuits offerts par les bookmakers.",
        category: "Bonus",
        readTime: "5 min",
        icon: "Gift",
        introduction: "Un freebet (ou pari gratuit) est un type de bonus offert par les bookmakers où seule la différence nette entre le gain total et la mise de départ vous est reversée en argent réel (cash retirable).",
        sections: [
            {
                id: "definition-freebet",
                title: "Définition et exemple concret",
                content: "Contrairement à un pari traditionnel où vous récupérez votre mise ET le gain, dans un freebet, la mise appartient au bookmaker. Si vous jouez un freebet de 10 € sur une cote de 3.00, le gain total théorique est de 30 €. En cas de victoire, vous recevrez uniquement 20 € de gain net (30 € - 10 € de mise) crédités en argent réel."
            },
            {
                id: "comment-obtenir",
                title: "Comment obtenir des freebets ?",
                content: "Les bookmakers distribuent des freebets lors de votre inscription (bonus de bienvenue sur premier pari perdant), durant les grands événements via des défis et promotions sur leurs sites, ou via des concours sur les réseaux sociaux."
            },
            {
                id: "optimisation",
                title: "Stratégies d'optimisation",
                content: "Comme la mise n'est pas restituée, il est mathématiquement plus rentable de placer vos freebets sur des cotes moyennement élevées (entre 2.00 et 4.00) pour générer un gain net appréciable, plutôt que sur des petites cotes."
            }
        ],
        faqs: [
            {
                q: "Puis-je retirer directement un freebet ?",
                a: "Non, un freebet ne peut pas être retiré directement sous forme d'argent. Vous devez obligatoirement le jouer et le gagner pour empocher le gain net."
            },
            {
                q: "Quelle est la durée de validité d'un freebet ?",
                a: "Cela dépend des bookmakers, mais la plupart des freebets expirent au bout de 7 à 30 jours s'ils ne sont pas utilisés."
            },
            {
                q: "Peut-on diviser un freebet en plusieurs paris ?",
                a: "Chez certains bookmakers (comme Winamax ou Betclic), vous pouvez fractionner vos freebets. Chez d'autres, they doivent être joués en une seule fois."
            }
        ]
    },
    {
        slug: "types-paris-football",
        title: "Les types de paris football expliqués",
        excerpt: "1N2, handicap, over/under, mi-temps, buteur... Tous les marchés foot décodés.",
        category: "Bases",
        readTime: "10 min",
        icon: "ListChecks",
        introduction: "Les bookmakers proposent plus de 200 types de paris par match de football. Les plus populaires sont le résultat final (1N2), la double chance, le nombre de buts (Plus/Moins), et les paris buteurs.",
        sections: [
            {
                id: "pari-1n2",
                title: "Le pari 1N2 classique",
                content: "C'est le pari le plus simple : pronostiquer le résultat à la fin du temps réglementaire (hors prolongations). Le '1' désigne la victoire de l'équipe à domicile, le 'N' le match nul, et le '2' la victoire de l'équipe à l'extérieur."
            },
            {
                id: "double-chance",
                title: "La Double Chance",
                content: "Ce pari vous permet de couvrir deux issues sur trois en un seul pronostic (ex: 1N pour victoire domicile ou nul, N2 pour nul ou victoire extérieur, 12 pour victoire de l'un ou de l'autre). La cote est plus basse, mais la probabilité de réussite est de 66.6%."
            },
            {
                id: "plus-moins-buts",
                title: "Over/Under (Plus ou Moins de buts)",
                content: "Il s'agit de pronostiquer si le nombre de buts marqués dans la rencontre sera supérieur ou inférieur à un seuil défini par le bookmaker (ex: Plus de 2,5 buts signifie qu'il faut au moins 3 buts dans le match pour gagner)."
            },
            {
                id: "paris-handicap",
                title: "Les paris à handicap",
                content: "Le bookmaker attribue un but d'avance ou de retard virtuel à une équipe. Par exemple, si vous pariez sur 'Équipe A (-1)', cette dernière doit l'emporter par au moins 2 buts d'écart pour que votre pari soit gagnant."
            }
        ],
        faqs: [
            {
                q: "Les prolongations comptent-elles dans le 1N2 ?",
                a: "Non, sauf mention explicite du bookmaker, tous les paris football portent uniquement sur le temps réglementaire (90 minutes de jeu plus les arrêts de jeu)."
            },
            {
                q: "Qu'est-ce que le pari 'Remboursé si Nul' (Draw No Bet) ?",
                a: "C'est un pari où vous misez sur la victoire d'une équipe, et si le match se termine par un nul, votre mise vous est intégralement remboursée."
            }
        ]
    },
    {
        slug: "comment-lire-une-cote",
        title: "Comment lire une cote ?",
        excerpt: "Cote décimale, probabilité implicite, valeur : maîtrisez la lecture des cotes en 5 minutes.",
        category: "Bases",
        readTime: "6 min",
        icon: "Calculator",
        introduction: "Pour lire une cote décimale, il suffit de comprendre qu'elle représente à la fois votre gain potentiel brut et l'estimation de probabilité faite par le bookmaker sur un événement.",
        sections: [
            {
                id: "calcul-gains",
                title: "Calculer ses gains potentiels",
                content: "La formule de calcul du gain brut est simple : Gain = Mise x Cote. Par exemple, si vous misez 10 € sur une cote de 1.80, le gain potentiel brut est de 18 € (10 € x 1.80). Votre bénéfice réel (gain net) est de 8 € (18 € de gain brut - 10 € de mise de départ)."
            },
            {
                id: "probabilite-implicite",
                title: "Déterminer la probabilité implicite",
                content: "La cote est inversement proportionnelle à la probabilité estimée par le bookmaker. Pour la calculer : Probabilité = 1 / Cote. Une cote de 2.00 équivaut à 1 / 2.00 = 50% de chances de réussite estimées. Une cote de 4.00 correspond à 1 / 4.00 = 25%."
            },
            {
                id: "value-bet",
                title: "Qu'est-ce qu'une value bet ?",
                content: "Une 'value bet' survient lorsque vous estimez que la probabilité réelle d'un événement est supérieure à celle calculée par le bookmaker. C'est l'essence même des paris sportifs professionnels à long terme."
            }
        ],
        faqs: [
            {
                q: "Pourquoi les cotes varient-elles dans le temps ?",
                a: "Les bookmakers font fluctuer les cotes en fonction des blessures de dernière minute, de la météo, et surtout de la répartition des mises des parieurs pour équilibrer leur propre risque."
            },
            {
                q: "Qu'est-ce que le taux de retour joueur (TRJ) ?",
                a: "C'est le pourcentage global des mises redistribué par le bookmaker sous forme de gains. En France, la loi limite le TRJ moyen à 85% pour prévenir le surendettement."
            }
        ]
    },
    {
        slug: "paris-combines-strategie",
        title: "Paris combinés foot : stratégie et conseils",
        excerpt: "Comment construire un combiné rentable et éviter les erreurs des parieurs débutants.",
        category: "Stratégie",
        readTime: "9 min",
        icon: "Layers",
        introduction: "Un pari combiné associe plusieurs pronostics indépendants sur un même ticket de pari. Les cotes de chaque sélection sont multipliées entre elles, augmentant drastiquement les gains potentiels, mais une seule erreur suffit à faire perdre l'intégralité du combiné.",
        sections: [
            {
                id: "multiplication-cotes",
                title: "Le principe multiplicateur",
                content: "Si vous combinez 3 matchs avec des cotes individuelles de 1.50, 2.00 et 1.80, la cote globale de votre ticket sera de 1.50 x 2.00 x 1.80 = 5.40. Une mise de 10 € peut ainsi vous rapporter 54 € de gains bruts."
            },
            {
                id: "limites-risques",
                title: "Limiter le nombre de sélections",
                content: "L'erreur classique des débutants est d'ajouter trop de matchs sur leur ticket. La probabilité mathématique de victoire diminue de manière exponentielle avec chaque sélection. Pour rester rentable, nous conseillons de limiter les combinés à 2 ou 3 sélections maximum."
            },
            {
                id: "combiner-favoris",
                title: "La fausse bonne idée des 'petites cotes'",
                content: "Combiner 5 favoris à des cotes de 1.15 semble facile, mais le football réserve toujours des surprises. Un seul nul d'un favori gâche votre pari, alors que le gain espéré n'était pas suffisant pour justifier le risque cumulé."
            }
        ],
        faqs: [
            {
                q: "Quelle est la différence entre combiné et système ?",
                a: "Un combiné nécessite que toutes les sélections soient correctes. Un pari système vous permet de remporter des gains même s'il y a une ou plusieurs erreurs (ex: système 2/3)."
            },
            {
                q: "Peut-on combiner deux paris sur le même match ?",
                a: "En règle générale, non. Pour combiner plusieurs événements d'une même rencontre, vous devez utiliser la fonctionnalité spécifique 'Bet Builder' (ou 'MyMatch' selon les opérateurs)."
            }
        ]
    },
    {
        slug: "marches-speciaux-buteur-score-exact",
        title: "Buteur, score exact, mi-temps : les marchés spéciaux",
        excerpt: "Découvrez les marchés à forte cote pour maximiser vos gains sur les paris football.",
        category: "Stratégie",
        readTime: "8 min",
        icon: "Target",
        introduction: "Les marchés spéciaux tels que les buteurs, les scores exacts, ou le résultat à la mi-temps offrent des cotes généralement supérieures à 2.50 et permettent de générer de gros bénéfices en exploitant des statistiques ciblées.",
        sections: [
            {
                id: "pari-buteur",
                title: "Le pari Buteur",
                content: "Consiste à désigner un joueur qui marquera au moins un but au cours de la rencontre (hors tirs au but). C'est un marché très intéressant si vous étudiez la forme physique actuelle d'un attaquant, s'il tire les penalties, ou face à une défense adverse affaiblie."
            },
            {
                id: "score-exact",
                title: "Le Score Exact",
                content: "Rechercher le score final précis à la fin du temps réglementaire (ex: 2-1). Les cotes y sont très élevées (souvent supérieures à 6.00). Pour l'optimiser, privilégiez les équipes au style défensif affirmé, où les scores étriqués de type 1-0 ou 1-1 sont fréquents."
            },
            {
                id: "mi-temps-fin-match",
                title: "Mi-temps / Fin de match",
                content: "Vous devez pronostiquer à la fois le résultat à la pause et le résultat au coup de sifflet final (ex: Match nul à la mi-temps, puis victoire de l'Équipe A en fin de match). Ce marché est particulièrement rentable pour les équipes qui ont tendance à fatiguer leurs adversaires en seconde période."
            }
        ],
        faqs: [
            {
                q: "Que se passe-t-il si mon joueur buteur ne rentre pas sur le terrain ?",
                a: "Si le joueur désigné ne prend pas part au match (n'entre pas en jeu), le règlement ANJ stipule que votre pari est annulé et votre mise remboursée à 100%."
            },
            {
                q: "Les buts contre leur camp (CSC) comptent-ils pour le pari buteur ?",
                a: "Non, les buts contre leur camp ne sont jamais attribués au joueur concerné pour les paris buteurs. Le pari continue de courir pour les autres buts du match."
            }
        ]
    }
];

export const COMPETITIONS = [
    {
        slug: "ligue-1",
        name: "Ligue 1",
        country: "France",
        season: "2025-2026",
        recommendedBookmaker: "winamax",
        description:
            "Le championnat de France de football compte 18 clubs avec un calendrier sur 34 journées. Winamax propose les meilleures cotes et le plus de marchés sur la Ligue 1 française.",
        teams: ["PSG", "OM", "Monaco", "Lyon", "Lille", "Nice", "Rennes", "Lens"],
    },
    {
        slug: "champions-league",
        name: "UEFA Champions League",
        country: "Europe",
        season: "2025-2026",
        recommendedBookmaker: "betclic",
        description:
            "La plus prestigieuse compétition européenne de clubs. Betclic propose une couverture exceptionnelle avec boost de cotes et streaming live.",
        teams: ["Real Madrid", "Manchester City", "Bayern Munich", "PSG", "Inter", "Arsenal"],
    },
    {
        slug: "coupe-de-france",
        name: "Coupe de France",
        country: "France",
        season: "2025-2026",
        recommendedBookmaker: "unibet",
        description:
            "La Coupe de France réserve toujours des surprises avec les rencontres amateurs vs pros. Unibet offre la meilleure couverture des tours préliminaires.",
        teams: ["Tous les clubs amateurs et pros français"],
    },
    {
        slug: "coupe-du-monde",
        name: "Coupe du Monde",
        country: "International",
        season: "2026",
        recommendedBookmaker: "winamax",
        description:
            "La Coupe du Monde FIFA 2026 réunit 48 nations à travers les États-Unis, le Canada et le Mexique. Winamax propose les meilleures cotes et le plus de marchés sur cet événement planétaire.",
        teams: ["France", "Argentine", "Brésil", "Espagne", "Angleterre", "Allemagne", "Portugal", "Pays-Bas"],
    },
    {
        slug: "premier-league",
        name: "Premier League",
        country: "Angleterre",
        season: "2025-2026",
        recommendedBookmaker: "betclic",
        description:
            "Le prestigieux championnat anglais avec les meilleurs clubs du monde. Cotes boostées et marchés variés disponibles sur Betclic.",
        teams: ["Manchester City", "Arsenal", "Liverpool", "Chelsea", "Manchester United", "Tottenham", "Aston Villa", "Newcastle"],
    },
    {
        slug: "la-liga",
        name: "La Liga",
        country: "Espagne",
        season: "2025-2026",
        recommendedBookmaker: "winamax",
        description:
            "Le championnat espagnol et ses géants comme le Real Madrid et le FC Barcelone. Suivez les cotes et analyses de matchs sur Winamax.",
        teams: ["Real Madrid", "FC Barcelone", "Atlético Madrid", "Real Sociedad", "Athletic Bilbao", "Girona", "Betis Séville"],
    },
    {
        slug: "serie-a",
        name: "Serie A",
        country: "Italie",
        season: "2025-2026",
        recommendedBookmaker: "unibet",
        description:
            "La compétition italienne réputée pour sa tactique et ses clubs historiques. Profitez de l'offre d'Unibet pour parier sur la Serie A.",
        teams: ["Inter Milan", "AC Milan", "Juventus", "Naples", "AS Rome", "Lazio", "Atalanta", "Fiorentina"],
    },
    {
        slug: "bundesliga",
        name: "Bundesliga",
        country: "Allemagne",
        season: "2025-2026",
        recommendedBookmaker: "winamax",
        description:
            "Le championnat allemand célèbre pour son football offensif et ses stades pleins. Cotes très élevées sur la Bundesliga chez Winamax.",
        teams: ["Bayern Munich", "Bayer Leverkusen", "Borussia Dortmund", "RB Leipzig", "VfB Stuttgart", "Eintracht Francfort"],
    },
    {
        slug: "europa-league",
        name: "Ligue Europa",
        country: "Europe",
        season: "2025-2026",
        recommendedBookmaker: "betclic",
        description:
            "La deuxième coupe d'Europe de clubs avec de magnifiques affiches. Suivez toute la compétition avec des cotes optimisées sur Betclic.",
        teams: ["Clubs européens qualifiés de premier plan"],
    },
    {
        slug: "primeira-liga",
        name: "Primeira Liga",
        country: "Portugal",
        season: "2025-2026",
        recommendedBookmaker: "unibet",
        description:
            "Le championnat portugais avec le FC Porto, le Benfica et le Sporting. Retrouvez tous les paris et cotes en direct sur Unibet.",
        teams: ["Benfica", "Sporting CP", "FC Porto", "Braga", "Vitória Guimarães"],
    },
    {
        slug: "pro-league",
        name: "Pro League",
        country: "Belgique",
        season: "2025-2026",
        recommendedBookmaker: "betclic",
        description:
            "Le championnat belge avec son système de playoffs palpitant. Pariez sur la Pro League avec les meilleures cotes sur Betclic.",
        teams: ["Club Bruges", "Anderlecht", "Union Saint-Gilloise", "Genk", "La Gantoise", "Antwerp"],
    },
    {
        slug: "eredivisie",
        name: "Eredivisie",
        country: "Pays-Bas",
        season: "2025-2026",
        recommendedBookmaker: "winamax",
        description:
            "La première division néerlandaise, réputée pour ses jeunes talents et ses scores fleuves. Suivez l'Eredivisie sur Winamax.",
        teams: ["PSV Eindhoven", "Ajax Amsterdam", "Feyenoord", "AZ Alkmaar", "FC Twente"],
    },
];

export const COMPETITIONS_HOME = [
    { name: "Coupe du Monde 2026", slug: "coupe-du-monde", emoji: "🏆" },
    { name: "Ligue 1", slug: "ligue-1", emoji: "🇫🇷" },
    { name: "UEFA Champions League", slug: "champions-league", emoji: "⚽" },
    { name: "Europa League", slug: "champions-league", emoji: "🥈" },
    { name: "Coupe de France", slug: "coupe-de-france", emoji: "🇫🇷" },
    { name: "Premier League", slug: "champions-league", emoji: "🇬🇧" },
];

export const ARTICLE_CATEGORIES = [
    "Tous",
    "Bonus",
    "Analyses",
    "Guides",
    "Pronostics",
];

export const getBookmakerBySlug = (slug) =>
    BOOKMAKERS.find((b) => b.slug === slug);

export const getCompetitionBySlug = (slug) =>
    COMPETITIONS.find((c) => c.slug === slug);

export const getGuideBySlug = (slug) => GUIDES.find((g) => g.slug === slug);

export const getArticleBySlug = (slug) =>
    ARTICLES.find((a) => a.slug === slug);
